export type ColorPalette = {
  id: string;
  primary: string;
  primaryLight: string;
  primaryBg: string;
};

export const COLOR_PALETTES: ColorPalette[] = [
  { id: "purple",    primary: "#6c5ce7", primaryLight: "#a29bfe", primaryBg: "#f0eeff" },
  { id: "blue",      primary: "#0984e3", primaryLight: "#74b9ff", primaryBg: "#e8f4fd" },
  { id: "green",     primary: "#00b894", primaryLight: "#55efc4", primaryBg: "#e8f8f0" },
  { id: "orange",    primary: "#e17055", primaryLight: "#fab1a0", primaryBg: "#fdecea" },
  { id: "pink",      primary: "#e84393", primaryLight: "#fd79a8", primaryBg: "#ffeef7" },
  { id: "teal",      primary: "#00cec9", primaryLight: "#81ecec", primaryBg: "#e8fffe" },
  { id: "red",       primary: "#d63031", primaryLight: "#ff7675", primaryBg: "#ffe0e0" },
  { id: "indigo",    primary: "#3949ab", primaryLight: "#7986cb", primaryBg: "#e8eaf6" },
  { id: "amber",     primary: "#f59f00", primaryLight: "#ffd43b", primaryBg: "#fff9db" },
  { id: "lime",      primary: "#7cb342", primaryLight: "#aed581", primaryBg: "#f1f8e9" },
  { id: "coral",     primary: "#ff6348", primaryLight: "#ff9f7f", primaryBg: "#fff0ec" },
  { id: "sky",       primary: "#0ea5e9", primaryLight: "#7dd3fc", primaryBg: "#e0f2fe" },
];

export const HERO_EMOJIS = [
  // Animals
  "🦊", "🦁", "🐱", "🐶", "🐼", "🦄", "🐸", "🐰",
  "🐯", "🐨", "🦓", "🦒", "🦘", "🦔", "🦦", "🐻",
  "🐮", "🐷", "🐺", "🦝", "🐹", "🦙", "🦬", "🐗",
  // Birds & sea
  "🦋", "🐝", "🦜", "🐬", "🐙", "🦖", "🐧", "🐳",
  "🦅", "🦉", "🦀", "🦑", "🦈", "🐠", "🐢", "🦎",
  // Space & magic
  "🌟", "🚀", "⚡", "🌈", "☄️", "🌙", "🪐", "👽",
  // Activities & objects
  "🎨", "🎵", "🏆", "👑", "💎", "🎮", "🎯", "🎲",
  "⚽", "🏀", "🎸", "🎭", "🧩", "🎪", "🎠", "🎡",
  // Fantasy & fun
  "🧙", "🦸", "🧜", "🧚", "🐲", "🧸", "🤖", "👾",
];

export function getPalette(id: string | undefined): ColorPalette {
  return COLOR_PALETTES.find((p) => p.id === id) ?? COLOR_PALETTES[0];
}
